import { faqAccordion } from '../utils/faq';
import { screenshotsAccordion } from '../utils/screenshots';

document.addEventListener('DOMContentLoaded', function (e) {
  faqAccordion();
  screenshotsAccordion();
  document.querySelectorAll(".feature-list").forEach(section => {
    const row = section.querySelector(".feature-list__row");
    const moreBtn = section.querySelector(".feature-list__toggle-more");
    const lessBtn = section.querySelector(".feature-list__toggle-less");
    if (!row || !moreBtn || !lessBtn) return;

    const defaultCount = parseInt(row.dataset.showDefault, 10);

    moreBtn.addEventListener("click", e => {
      e.preventDefault();
      row.querySelectorAll(".feature-list__item").forEach((el, idx) => {
        if (idx >= defaultCount) el.classList.remove("is-hidden");
      });
      moreBtn.classList.add("is-hidden");
      lessBtn.classList.remove("is-hidden");
    });

    lessBtn.addEventListener("click", e => {
      e.preventDefault();
      row.querySelectorAll(".feature-list__item").forEach((el, idx) => {
        if (idx >= defaultCount) el.classList.add("is-hidden");
      });
      lessBtn.classList.add("is-hidden");
      moreBtn.classList.remove("is-hidden");
    });
  });
});
